import React from 'react';
import moment from 'moment';
// import ColoredScrollbars from './ColoredScrollbars';
import { Link } from 'react-router-dom';
const Suggestion = (props) => {
    // console.log(props)
    let data = props.results;
    let x = Object.keys(data);
    const options = x.map(r => {
        


        return (

            <li key={r} className="media suggestion" style={{ padding: 5, lineHeight: '18px', justifyContent: 'space-between' }}>
                <Link to={"/event/" + r} className="d-flex justify-content-between" style={{width:'100%'}} >
                    .<img src={"http://kingdeportes.com/geek/themes/flat/img/logos/"+data[r].ihome+".png"} width='50' height='50' alt="..." className="rounded-circle mx-2" />
                    <div className="" style={{ width: 'calc(100% - 132px)',flex:'none' }}>
                        <span className="mt-0 mb-1 text-truncate d-block" style={{ textAlign: 'center', width: '100%', fontSize:16 }}>{moment(data[r].timestamp * 1000).format('H:mm') + " - " + data[r].name}</span>
                        <span className="d-inline-block text-truncate" style={{ width: '100%', fontSize:12 }}><i className={"icon sicon-sport-" + data[r].sport} style={{ fontSize: 20, paddingRight: 5 }}></i>{moment(data[r].timestamp * 1000).format('MMM DD, YYYY') + " - " + data[r].liga}</span>
                    </div>
                    <img src={"http://kingdeportes.com/geek/themes/flat/img/logos/"+data[r].iaway+".png"} width='50' height='50' alt="..." className="rounded-circle mx-2" /*style={{ position: 'absolute', right: 0 }}*/ />
                </Link>
            </li>

        )
    })
    return (

        <div style={{ backgroundColor: '#12242e', zIndex: "1", width: '100%', top: 50, boxShadow: '0px 0px 6px #17a2b8', position: "absolute", display: x.length > 0 ? 'block' : 'none' }}>
            <ul className="list-unstyled">
                {options}

            </ul>
        </div>
    )
}

export default Suggestion


// WEBPACK FOOTER //
// ./src/components/Suggestion.js